// extracted by mini-css-extract-plugin
export var centered = "_n-6";
export var flexible = "_n-5";
export var footer = "_n-k";
export var footerBorder = "_n-l";
export var header = "_n-c";
export var headerBorder = "_n-d";
export var headerDefault = "_n-g";
export var headerMedium = "_n-h";
export var headerPadding = "_n-e";
export var iconAndTitle = "_n-f";
export var large = "_n-4";
export var largePadding = "_n-a";
export var medium = "_n-3";
export var mediumPadding = "_n-9";
export var modal = "_n-0";
export var modalContainer = "_n-b";
export var noPadding = "_n-7";
export var skinny = "_n-1";
export var small = "_n-2";
export var smallPadding = "_n-8";
export var subtitle = "_n-j";
export var title = "_n-i";